

export const commonBase = {
  "kibt_color_base_black_0": "#222222",
  "kibt_color_base_black_0_a50": "#22222280",
  "kibt_color_base_black_1_a55": "#2222228C",
  "kibt_color_base_black_1_a95": "#222222F2",
  "kibt_color_base_black_16": "#1F1F1F",
  "kibt_color_base_black_17": "#474747",
  "kibt_color_base_black_18": "#999999",
  "kibt_color_base_black_19": "#ADADAD",
  "kibt_color_base_black_2": "#666666",
  "kibt_color_base_black_2_a65": "#666666A6",
  "kibt_color_base_black_20": "#C2C2C2",
  "kibt_color_base_black_21": "#3D3D3D",
  "kibt_color_base_black_22": "#F2F2F2",
  "kibt_color_base_black_25": "#112255",
  "kibt_color_base_black_26_a20": "#40404033",
  "kibt_color_base_black_27": "#F7F7F7FF",
  "kibt_color_base_black_3": "#9C9C9C",
  "kibt_color_base_black_30_a40": "#3E3E3E66",
  "kibt_color_base_black_31_a72": "#1C1C1CB8",
  "kibt_color_base_black_32": "#121212",
  "kibt_color_base_black_4_a80": "#C6C6C6CC",
  "kibt_color_base_black_6": "#2B2B2F",
  "kibt_color_base_black_7": "#000000",
  "kibt_color_base_black_7_a0": "#00000000",
  "kibt_color_base_black_7_a10": "#0000001A",
  "kibt_color_base_black_7_a12": "#0000001F",
  "kibt_color_base_black_7_a24": "#0000003D",
  "kibt_color_base_black_7_a32": "#00000052",
  "kibt_color_base_black_7_a4": "#0000000A",
  "kibt_color_base_black_7_a40": "#00000066",
  "kibt_color_base_black_7_a5": "#0000000D",
  "kibt_color_base_black_7_a56": "#0000008F",
  "kibt_color_base_black_7_a64": "#000000A3",
  "kibt_color_base_black_7_a72": "#000000B8",
  "kibt_color_base_black_7_a88": "#000000E0",
  "kibt_color_base_black_7_a96": "#000000F5",
  "kibt_color_base_blue_1": "#5181FB",
  "kibt_color_base_cyan_0": "#004182",
  "kibt_color_base_cyan_1_a40": "#00418266",
  "kibt_color_base_cyan_1_for_test": "#00FFFF",
  "kibt_color_base_cyan_2": "#158CE9",
  "kibt_color_base_cyan_3": "#00C36A",
  "kibt_color_base_cyan_4": "#168FFF",
  "kibt_color_base_gold_1": "#FAA627",
  "kibt_color_base_green_1": "#00BD5C",
  "kibt_color_base_orange_1_a50": "#FF490680",
  "kibt_color_base_orange_1_a60": "#FF490699",
  "kibt_color_base_orange_2": "#FFEFE1",
  "kibt_color_base_orange_3": "#FF6200",
  "kibt_color_base_purple_1": "#B34BBC",
  "kibt_color_base_red_0": "#FF4906",
  "kibt_color_base_red_0_a12": "#FF49061F",
  "kibt_color_base_red_2": "#FF3A30",
  "kibt_color_base_red_3": "#FF0000",
  "kibt_color_base_red_3_a12": "#FF00001F",
  "kibt_color_base_white_0": "#C6C6C6",
  "kibt_color_base_white_2": "#F1F1F1",
  "kibt_color_base_white_21": "#FAFAFA",
  "kibt_color_base_white_3": "#F9F9FC",
  "kibt_color_base_white_4": "#FFFFFF",
  "kibt_color_base_white_4_a10": "#FFFFFF1A",
  "kibt_color_base_white_4_a100": "#FFFFFFFF",
  "kibt_color_base_white_4_a12": "#FFFFFF1F",
  "kibt_color_base_white_4_a20": "#FFFFFF33",
  "kibt_color_base_white_4_a24": "#FFFFFF3D",
  "kibt_color_base_white_4_a30": "#FFFFFF4D",
  "kibt_color_base_white_4_a4": "#FFFFFF0A",
  "kibt_color_base_white_4_a40": "#FFFFFF66",
  "kibt_color_base_white_4_a5": "#FFFFFF0D",
  "kibt_color_base_white_4_a50": "#FFFFFF80",
  "kibt_color_base_white_4_a64": "#FFFFFFA3",
  "kibt_color_base_white_4_a70": "#FFFFFFB3",
  "kibt_color_base_white_4_a80": "#FFFFFFCC",
  "kibt_color_base_white_4_a88": "#FFFFFFE0",
  "kibt_color_base_white_4_a90": "#FFFFFFE6",
  "kibt_color_base_white_4_a95": "#FFFFFFF2",
  "kibt_color_base_yellow_0": "#FFC400",
  "kibt_color_base_yellow_2": "#FFDD00",
  "kibt_color_base_yellow_3": "#FFF000",
  "kibt_color_base_yellow_4": "#FFF100",
  "kibt_color_base_yellow_5_a100": "#FFD373FF"
}

export const colorScene = {
  "kibt_cs_common_background_balck": "var(--kibt_cs_common_background_balck)",
  "kibt_cs_common_background_balckprimaryreal": "var(--kibt_cs_common_background_balckprimaryreal)",
  "kibt_cs_common_background_balckquaternaryreal": "var(--kibt_cs_common_background_balckquaternaryreal)",
  "kibt_cs_common_background_balcktertiaryreal": "var(--kibt_cs_common_background_balcktertiaryreal)",
  "kibt_cs_common_background_bgmask": "var(--kibt_cs_common_background_bgmask)",
  "kibt_cs_common_background_bgmaskonblack": "var(--kibt_cs_common_background_bgmaskonblack)",
  "kibt_cs_common_background_bgmaskwhite": "var(--kibt_cs_common_background_bgmaskwhite)",
  "kibt_cs_common_background_bgweek": "var(--kibt_cs_common_background_bgweek)",
  "kibt_cs_common_background_blacksecondary": "var(--kibt_cs_common_background_blacksecondary)",
  "kibt_cs_common_background_blacksecondaryreal": "var(--kibt_cs_common_background_blacksecondaryreal)",
  "kibt_cs_common_background_brand": "var(--kibt_cs_common_background_brand)",
  "kibt_cs_common_background_danger": "var(--kibt_cs_common_background_danger)",
  "kibt_cs_common_background_grayprimaryreal": "var(--kibt_cs_common_background_grayprimaryreal)",
  "kibt_cs_common_background_graysecondaryreal": "var(--kibt_cs_common_background_graysecondaryreal)",
  "kibt_cs_common_background_label": "var(--kibt_cs_common_background_label)",
  "kibt_cs_common_background_link": "var(--kibt_cs_common_background_link)",
  "kibt_cs_common_background_livetextbg": "var(--kibt_cs_common_background_livetextbg)",
  "kibt_cs_common_background_success": "var(--kibt_cs_common_background_success)",
  "kibt_cs_common_background_tag": "var(--kibt_cs_common_background_tag)",
  "kibt_cs_common_background_themeui": "var(--kibt_cs_common_background_themeui)",
  "kibt_cs_common_background_tips": "var(--kibt_cs_common_background_tips)",
  "kibt_cs_common_background_weekbuttonwhite": "var(--kibt_cs_common_background_weekbuttonwhite)",
  "kibt_cs_common_background_white": "var(--kibt_cs_common_background_white)",
  "kibt_cs_common_background_whiteprimaryreal": "var(--kibt_cs_common_background_whiteprimaryreal)",
  "kibt_cs_common_background_whitesecondarywhite": "var(--kibt_cs_common_background_whitesecondarywhite)",
  "kibt_cs_common_stroke_border": "var(--kibt_cs_common_stroke_border)",
  "kibt_cs_common_stroke_borderonbalck": "var(--kibt_cs_common_stroke_borderonbalck)",
  "kibt_cs_common_stroke_buttonborder": "var(--kibt_cs_common_stroke_buttonborder)",
  "kibt_cs_common_stroke_buttonborderonblack": "var(--kibt_cs_common_stroke_buttonborderonblack)",
  "kibt_cs_common_stroke_buttonorange": "var(--kibt_cs_common_stroke_buttonorange)",
  "kibt_cs_common_stroke_navigation": "var(--kibt_cs_common_stroke_navigation)",
  "kibt_cs_common_text_black": "var(--kibt_cs_common_text_black)",
  "kibt_cs_common_text_danger": "var(--kibt_cs_common_text_danger)",
  "kibt_cs_common_text_describe": "var(--kibt_cs_common_text_describe)",
  "kibt_cs_common_text_gold": "var(--kibt_cs_common_text_gold)",
  "kibt_cs_common_text_link": "var(--kibt_cs_common_text_link)",
  "kibt_cs_common_text_livenotice": "var(--kibt_cs_common_text_livenotice)",
  "kibt_cs_common_text_primary": "var(--kibt_cs_common_text_primary)",
  "kibt_cs_common_text_primarywhite": "var(--kibt_cs_common_text_primarywhite)",
  "kibt_cs_common_text_quaternary": "var(--kibt_cs_common_text_quaternary)",
  "kibt_cs_common_text_quaternarywhite": "var(--kibt_cs_common_text_quaternarywhite)",
  "kibt_cs_common_text_secondary": "var(--kibt_cs_common_text_secondary)",
  "kibt_cs_common_text_secondarywhite": "var(--kibt_cs_common_text_secondarywhite)",
  "kibt_cs_common_text_success": "var(--kibt_cs_common_text_success)",
  "kibt_cs_common_text_tertiary": "var(--kibt_cs_common_text_tertiary)",
  "kibt_cs_common_text_themeui": "var(--kibt_cs_common_text_themeui)"
}

export const colorSceneLight = {
  "kibt_cs_common_background_balck": "#000000",
  "kibt_cs_common_background_balckprimaryreal": "#1F1F1F",
  "kibt_cs_common_background_balckquaternaryreal": "#ADADAD",
  "kibt_cs_common_background_balcktertiaryreal": "#999999",
  "kibt_cs_common_background_bgmask": "rgba(0,0,0,0.051)",
  "kibt_cs_common_background_bgmaskonblack": "rgba(255,255,255,0.051)",
  "kibt_cs_common_background_bgmaskwhite": "rgba(255,255,255,0.12)",
  "kibt_cs_common_background_bgweek": "rgba(0,0,0,0.24)",
  "kibt_cs_common_background_blacksecondary": "rgba(0,0,0,0.72)",
  "kibt_cs_common_background_blacksecondaryreal": "#474747",
  "kibt_cs_common_background_brand": "#FF4906",
  "kibt_cs_common_background_danger": "#FF0000",
  "kibt_cs_common_background_grayprimaryreal": "#C2C2C2",
  "kibt_cs_common_background_graysecondaryreal": "#F2F2F2",
  "kibt_cs_common_background_label": "rgba(255,73,6,0.12)",
  "kibt_cs_common_background_link": "#168FFF",
  "kibt_cs_common_background_livetextbg": "rgba(0,0,0,0.32)",
  "kibt_cs_common_background_success": "#00BD5C",
  "kibt_cs_common_background_tag": "rgba(0,0,0,0.40)",
  "kibt_cs_common_background_themeui": "#FF4906",
  "kibt_cs_common_background_tips": "rgba(255,0,0,0.12)",
  "kibt_cs_common_background_weekbuttonwhite": "rgba(255,255,255,0.24)",
  "kibt_cs_common_background_white": "#FFFFFF",
  "kibt_cs_common_background_whiteprimaryreal": "#1F1F1F",
  "kibt_cs_common_background_whitesecondarywhite": "#3D3D3D",
  "kibt_cs_common_stroke_border": "rgba(0,0,0,0.051)",
  "kibt_cs_common_stroke_borderonbalck": "rgba(255,255,255,0.051)",
  "kibt_cs_common_stroke_buttonborder": "rgba(0,0,0,0.12)",
  "kibt_cs_common_stroke_buttonborderonblack": "rgba(255,255,255,0.24)",
  "kibt_cs_common_stroke_buttonorange": "#FF4906",
  "kibt_cs_common_stroke_navigation": "rgba(255,255,255,0.40)",
  "kibt_cs_common_text_black": "#000000",
  "kibt_cs_common_text_danger": "#FF0000",
  "kibt_cs_common_text_describe": "rgba(255,255,255,0.88)",
  "kibt_cs_common_text_gold": "#FAA627",
  "kibt_cs_common_text_link": "#004182",
  "kibt_cs_common_text_livenotice": "#FFDD00",
  "kibt_cs_common_text_primary": "rgba(0,0,0,0.88)",
  "kibt_cs_common_text_primarywhite": "#FFFFFF",
  "kibt_cs_common_text_quaternary": "rgba(0,0,0,0.24)",
  "kibt_cs_common_text_quaternarywhite": "rgba(255,255,255,0.40)",
  "kibt_cs_common_text_secondary": "rgba(0,0,0,0.64)",
  "kibt_cs_common_text_secondarywhite": "rgba(255,255,255,0.64)",
  "kibt_cs_common_text_success": "#00BD5C",
  "kibt_cs_common_text_tertiary": "rgba(0,0,0,0.40)",
  "kibt_cs_common_text_themeui": "#FF4906"
}

export const colorSceneDark = {
  "kibt_cs_common_background_balck": "#000000",
  "kibt_cs_common_background_balckprimaryreal": "#1F1F1F",
  "kibt_cs_common_background_balckquaternaryreal": "#ADADAD",
  "kibt_cs_common_background_balcktertiaryreal": "#999999",
  "kibt_cs_common_background_bgmask": "rgba(0,0,0,0.051)",
  "kibt_cs_common_background_bgmaskonblack": "rgba(255,255,255,0.051)",
  "kibt_cs_common_background_bgmaskwhite": "rgba(255,255,255,0.12)",
  "kibt_cs_common_background_bgweek": "rgba(0,0,0,0.24)",
  "kibt_cs_common_background_blacksecondary": "rgba(0,0,0,0.72)",
  "kibt_cs_common_background_blacksecondaryreal": "#474747",
  "kibt_cs_common_background_brand": "#FF4906",
  "kibt_cs_common_background_danger": "#FF0000",
  "kibt_cs_common_background_grayprimaryreal": "#C2C2C2",
  "kibt_cs_common_background_graysecondaryreal": "#F2F2F2",
  "kibt_cs_common_background_label": "rgba(255,73,6,0.12)",
  "kibt_cs_common_background_link": "#168FFF",
  "kibt_cs_common_background_livetextbg": "rgba(0,0,0,0.32)",
  "kibt_cs_common_background_success": "#00BD5C",
  "kibt_cs_common_background_tag": "rgba(0,0,0,0.40)",
  "kibt_cs_common_background_themeui": "#FF4906",
  "kibt_cs_common_background_tips": "rgba(255,0,0,0.12)",
  "kibt_cs_common_background_weekbuttonwhite": "rgba(255,255,255,0.24)",
  "kibt_cs_common_background_white": "#FFFFFF",
  "kibt_cs_common_background_whiteprimaryreal": "#1F1F1F",
  "kibt_cs_common_background_whitesecondarywhite": "#3D3D3D",
  "kibt_cs_common_stroke_border": "rgba(0,0,0,0.051)",
  "kibt_cs_common_stroke_borderonbalck": "rgba(255,255,255,0.051)",
  "kibt_cs_common_stroke_buttonborder": "rgba(0,0,0,0.12)",
  "kibt_cs_common_stroke_buttonborderonblack": "rgba(255,255,255,0.24)",
  "kibt_cs_common_stroke_buttonorange": "#FF4906",
  "kibt_cs_common_stroke_navigation": "rgba(255,255,255,0.40)",
  "kibt_cs_common_text_black": "#000000",
  "kibt_cs_common_text_danger": "#FF0000",
  "kibt_cs_common_text_describe": "rgba(255,255,255,0.88)",
  "kibt_cs_common_text_gold": "#FAA627",
  "kibt_cs_common_text_link": "#004182",
  "kibt_cs_common_text_livenotice": "#FFDD00",
  "kibt_cs_common_text_primary": "rgba(0,0,0,0.88)",
  "kibt_cs_common_text_primarywhite": "#FFFFFF",
  "kibt_cs_common_text_quaternary": "rgba(0,0,0,0.24)",
  "kibt_cs_common_text_quaternarywhite": "rgba(255,255,255,0.40)",
  "kibt_cs_common_text_secondary": "rgba(0,0,0,0.64)",
  "kibt_cs_common_text_secondarywhite": "rgba(255,255,255,0.64)",
  "kibt_cs_common_text_success": "#00BD5C",
  "kibt_cs_common_text_tertiary": "rgba(0,0,0,0.40)",
  "kibt_cs_common_text_themeui": "#FF4906"
}
